module.exports = __webpack_public_path__ + "img/block-illustration-adapt.svg";